// extracted by mini-css-extract-plugin
export var container = "m_bz";
export var container_hideOnMobile = "m_bB";
export var container_thin = "m_bC";